import { createFileRoute, useParams } from '@tanstack/react-router';

import { AssessmentAssignScreen } from '@/features/assessments/components/workspace/AssessmentAssignScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/assessments/$templateId/assign')({
  beforeLoad: () => {
    requirePermission('assessment:assign');
  },
  component: Wrap,
  staticData: { crumb: 'Assign' },
});

function Wrap() {
  const { templateId } = useParams({ from: '/app/assessments/$templateId/assign' });
  return <AssessmentAssignScreen templateId={templateId} surface="clinical" />;
}
